import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 20v-10a6 6 0 0 1 6 -6h10","key":"svg-0"}]]

const IconBorderCornerRounded = createReactComponent('outline', 'border-corner-rounded', 'BorderCornerRounded', __iconNode);

export default IconBorderCornerRounded;